import React from 'react';
// import Carousel from 'react-bootstrap/Carousel';

import 'bootstrap/dist/css/bootstrap.min.css';

import Navbar from "../../components/Navbar/Navbar";
import classes from './AddPage.module.css';

import Foot from "../../components/Foot/Foot";
import Spinner from 'react-bootstrap/Spinner';
import AddPerfume from "../../components/AddPerfume/AddPerfume";

function AddPage(){
  
    return(
        <div className={classes.container}>

                    
        <Navbar className={classes.Nav}/>

        <AddPerfume/>
     
        

       
       
                

        <Foot/>
      </div>
    )
}


export default AddPage;   